import { Link } from "@tanstack/react-router";
import { Compass } from "lucide-react";

import { Button } from "@/components/ui/button";

export function NotFound() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-subtle">
          <Compass className="h-5 w-5 text-text-muted" />
        </div>
        <h2 className="text-lg font-medium">Page not found</h2>
        <p className="mt-1 text-sm text-text-muted">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-4">
          <Button asChild variant="secondary" size="sm">
            <Link to="/inbox">Back to inbox</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
